import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import KvPcImg01 from 'ui/images/top_for_buyer/kv_pc_img_01.png';
import KvPcImg02 from 'ui/images/top_for_buyer/kv_pc_img_02.png';
import KvPcImg03 from 'ui/images/top_for_buyer/kv_pc_img_03.png';
import KvPcImg04 from 'ui/images/top_for_buyer/kv_pc_img_04.png';
import KvPcImg05 from 'ui/images/top_for_buyer/kv_pc_img_05.png';

import KvBalloonImg01 from 'ui/images/top_for_buyer/kv_balloon_img_01.svg';
import KvBalloonImg02 from 'ui/images/top_for_buyer/kv_balloon_img_02.svg';
import KvBalloonImg03 from 'ui/images/top_for_buyer/kv_balloon_img_03.svg';
import KvBalloonImg04 from 'ui/images/top_for_buyer/kv_balloon_img_04.svg';

import KvBalloonSPImg01 from 'ui/images/top/kv_simg_balloon_sp_01.png';
import KvBalloonSPImg02 from 'ui/images/top/kv_simg_balloon_sp_02.png';
import KvBalloonSPImg03 from 'ui/images/top/kv_simg_balloon_sp_03.png';
import KvBalloonSPImg04 from 'ui/images/top/kv_simg_balloon_sp_04.png';
import KvBalloonSPImg05 from 'ui/images/top/kv_simg_balloon_sp_05.png';
import KvBalloonSPImg06 from 'ui/images/top/kv_simg_balloon_sp_06.png';
import KvBalloonSPImg07 from 'ui/images/top/kv_simg_balloon_sp_07.png';
import KvBalloonSPImg08 from 'ui/images/top/kv_simg_balloon_sp_08.png';
import KVImgSp01 from 'ui/images/top/kv_sp_img_01.png';
import KVImgSp02 from 'ui/images/top/kv_sp_img_02.png';
import KVImgSp03 from 'ui/images/top/kv_sp_img_03.png';
import KVImgSp04 from 'ui/images/top/kv_sp_img_04.png';
import KVImgSp05 from 'ui/images/top/kv_sp_img_05.png';
import KVImgSp06 from 'ui/images/top/kv_sp_img_06.png';
import KVImgSp07 from 'ui/images/top/kv_sp_img_07.png';
import KVImgSp08 from 'ui/images/top/kv_sp_img_08.png';
import { mqMin } from 'utils/responsive';
import { Only } from 'ui/components/elements/Only/Only';

const KvIllust = styled.div`
    z-index: 2;
    ${mqMin('NARROW')} {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 1512px;
        height: 100%;
    }

    @keyframes kvPoyon {
        0% {
            opacity: 0;
            transform: scale(0.8);
        }
        40% {
            transform: scale(1);
        }
        65% {
            transform: scale(0.95, 1.05);
        }
        75% {
            transform: scale(1.03, 0.97);
        }
        85% {
            transform: scale(0.98, 1.02);
        }
        90% {
            transform: scale(1.01, 0.99);
        }
        100% {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
`;

const ImgContainer01 = styled.div`
    display: block;
    position: absolute;
    bottom: 10.4rem;
    left: -2rem;
    width: 14rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
    z-index: 1;

    ${mqMin('SP')} {
        bottom: 6.4rem;
        left: -2rem;
        width: 22rem;
    }

    ${mqMin('NARROW')} {
        bottom: 0;
        left: 4.6rem;
        width: 24rem;
    }
`;

const ImgContainer02 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        bottom: 0;
        right: 13.1rem;
        width: 17.4rem;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.4s forwards;
        z-index: 3;
    }
`;

const ImgContainer03 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        bottom: 0;
        right: 8.8rem;
        width: 8.8rem;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.8s forwards;
        z-index: 4;
    }
`;

const ImgContainer04 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        bottom: -0.8rem;
        right: 2.6rem;
        width: 11.2rem;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 1.2s forwards;
        z-index: 5;
    }
`;

const ImgContainer05 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 8.4rem;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 1.6s forwards;
        z-index: 6;
    }
`;

const ImgBalloon01 = styled.div`
    display: block;
    position: absolute;
    bottom: 25.7rem;
    left: 1rem;
    width: 7.8rem;
    opacity: 0;
    z-index: 1;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;

    img {
        min-width: initial;
    }

    ${mqMin('SP')} {
        bottom: 29.7rem;
        left: 4.5rem;
        width: 12.8rem;
    }

    ${mqMin('NARROW')} {
        bottom: initial;
        top: 14rem;
        left: 18rem;
        width: 17rem;
    }
`;
const ImgBalloon02 = styled.div`
    display: block;
    position: absolute;
    top: 20.3rem;
    left: 31rem;
    width: 8rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.6s forwards;
    transform-origin: bottom right;
`;

const ImgBalloon03 = styled.div`
    display: block;
    position: absolute;
    top: 23.5rem;
    left: 39.2rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 1s forwards;
    transform-origin: bottom left;
`;

const ImgBalloon04 = styled.div`
    display: block;
    position: absolute;
    top: 17rem;
    right: 20.4rem;
    width: 9rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 1.2s forwards;
    transform-origin: bottom right;
`;

const ImgContainerSP01 = styled.div`
    bottom: 10.2rem;
    right: 1.7rem;
    width: 12rem;
    display: block;
    position: absolute;
    z-index: 1;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        bottom: 6.5rem;
        right: 3.6rem;
        width: 17rem;
    }
`;

const ImgBalloonSP01 = styled.div`
    display: block;
    position: absolute;
    bottom: 26rem;
    right: -0.1rem;
    width: 5rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;

    ${mqMin('SP')} {
        bottom: 29rem;
        width: 8rem;
    }
`;

const ImgContainerSP02 = styled.div`
    position: absolute;
    z-index: 1;
    bottom: 10.2rem;
    right: -1.3rem;
    width: 6.1rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        bottom: 6.5rem;
        width: 8.6rem;
    }
`;

const ImgContainerSP03 = styled.div`
    bottom: 10.2rem;
    right: 1.7rem;
    width: 7.2rem;
    display: block;
    position: absolute;
    z-index: 1;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
`;

const ImgBalloonSP02 = styled.div`
    display: block;
    position: absolute;
    bottom: 19.5rem;
    right: 6rem;
    z-index: 2;
    width: 5rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;
`;

const ImgContainerSP04 = styled.div`
    position: absolute;
    z-index: 1;
    bottom: 10.2rem;
    right: -1.3rem;
    width: 6.1rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
`;

const FadeWrap = styled.div<{ visible: boolean }>`
    transition: opacity 0.8s;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

const KvSpSetSwitcher: React.FC = () => {
    const SETS = [
        [
            (current: number) => (
                <ImgContainerSP01 key={`img1-${current}`} style={{ animationDelay: '0.0s' }}>
                    <img src={KvPcImg02} alt="イラスト1" />
                </ImgContainerSP01>
            ),
            (current: number) => (
                <ImgBalloonSP01 key={`bal1-${current}`} style={{ animationDelay: '0.15s' }}>
                    <img src={KvBalloonImg04} alt="吹き出し1" />
                </ImgBalloonSP01>
            ),
            (current: number) => (
                <ImgContainerSP02 key={`img2-${current}`} style={{ animationDelay: '0.3s' }}>
                    <img src={KvPcImg03} alt="イラスト2" />
                </ImgContainerSP02>
            ),
        ],
        [
            (current: number) => (
                <ImgContainerSP03 key={`img3-${current}`} style={{ animationDelay: '0.0s' }}>
                    <img src={KvPcImg04} alt="イラスト3" />
                </ImgContainerSP03>
            ),
            (current: number) => (
                <ImgBalloonSP02 key={`bal3-${current}`} style={{ animationDelay: '0.15s' }}>
                    <img src={KvBalloonImg02} alt="吹き出し2" />
                </ImgBalloonSP02>
            ),
            (current: number) => (
                <ImgContainerSP04 key={`img4-${current}`} style={{ animationDelay: '0.3s' }}>
                    <img src={KvPcImg03} alt="イラスト4" />
                </ImgContainerSP04>
            ),
        ],
    ];
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % SETS.length);
        }, 2500);
        return () => clearInterval(timer);
    }, []);
    return (
        <>
            {SETS.map((set, idx) => (
                <FadeWrap key={idx} visible={idx === current}>
                    {idx === current && set.map((fn) => fn(current))}
                </FadeWrap>
            ))}
        </>
    );
};

export const KvPictures: React.FC = () => {
    return (
        <KvIllust>
            <ImgContainer01>
                <img src={KvPcImg01} alt="イラスト1" />
            </ImgContainer01>
            <Only sp>
                <ImgBalloon01>
                    <img src={KvBalloonImg01} alt="吹き出し1" />
                </ImgBalloon01>
            </Only>
            <Only pc>
                <ImgContainer02>
                    <img src={KvPcImg02} alt="イラスト2" />
                </ImgContainer02>
                <ImgContainer03>
                    <img src={KvPcImg03} alt="イラスト3" />
                </ImgContainer03>
                <ImgContainer04>
                    <img src={KvPcImg04} alt="イラスト4" />
                </ImgContainer04>
                <ImgContainer05>
                    <img src={KvPcImg05} alt="イラスト5" />
                </ImgContainer05>
                <ImgBalloon01>
                    <img src={KvBalloonImg01} alt="吹き出し1" />
                </ImgBalloon01>
                <ImgBalloon02>
                    <img src={KvBalloonImg02} alt="吹き出し2" />
                </ImgBalloon02>
                <ImgBalloon03>
                    <img src={KvBalloonImg03} alt="吹き出し3" />
                </ImgBalloon03>
                <ImgBalloon04>
                    <img src={KvBalloonImg04} alt="吹き出し4" />
                </ImgBalloon04>
            </Only>
            <Only sp>
                <KvSpSetSwitcher />
            </Only>
        </KvIllust>
    );
};
